module.exports = __webpack_public_path__ + "static/media/m_hairstyle_slickedback_front_shadow.b0ed0147.png";